import { all, put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import { TIERS_PER_FETCH } from '../constants';
import { getTierStreamId } from '../helpers';

function* handleInitTierStream(): SagaIterator {
  const streamId = getTierStreamId();

  const isStreamInitialized: ReturnType<typeof selectors.isInitialized> = yield select(
    selectors.isInitialized,
    streamId
  );
  if (isStreamInitialized) {
    return;
  }

  yield all([
    put(
      withOffset.actions.initialize({
        streamId,
        itemsPerFetch: TIERS_PER_FETCH,
      })
    ),
    put(withOffset.actions.fetch(streamId)),
  ]);
}

export default handleInitTierStream;
